<template>
  <div class="post-card">
    <div class="post-card-main">
      <img class="post-card-img" @click="goPage" v-if="post && post.coverPhoto" :src="post.coverPhoto.url"/>
      <div class="post-card-content">
        <div class="post-card-title" @click="goPage"><span class="title-content">{{post.title}}</span><span class="sign" v-if="post.auditState !== 4 && !audit" :style="{ color: sign[post.auditState-1].color, borderWidth: 1 + 'px', borderStyle: 'solid'}">{{sign[post.auditState-1].content}}</span></div>
        <div class="post-card-context">{{post.text}}</div>
        <div class="post-card-tag">
          <span v-for="(item, index) in post.tags" :key="index">{{item.label}}</span>
        </div>
      </div>
    </div>

    <div v-if="edit" class="post-card-infor" style="justify-content: flex-start;">
       <span class="post-card-tools" @click="editPost" v-if="post.auditState !== 2"><i class="user-edit"></i><span>编辑</span></span>
       <span class="post-card-tools" @click="deleteUserPost" v-if="post.auditState !== 2"><i class="user-delete"></i><span>删除</span></span>
       <span class="post-card-tools" @click="referUserPost" v-if="post.auditState === 1 || post.auditState === 3"><i class="user-submitaudit"></i><span>提交评审</span></span>
       <span class="post-card-tools" @click="noPastUserPost" v-if="post.auditState === 2 && audit"><i class="user-noreview"></i><span>未通过评审</span></span>
       <span class="post-card-tools" @click="pastUserPost" v-if="post.auditState === 2 && audit"><i class="user-finishreview"></i><span>通过评审</span></span>
    </div>
    <div v-else class="post-card-infor">
      <div class="post-card-user">
        <img :src="post.user.avatar"/>
        <span>{{post.name || post.user.nickname}}</span>
        <span style="color:rgba(153,153,153,1);">{{post.updated_at && post.updated_at.day}}</span>
      </div>
      <div class="post-card-follow">
        <img :src="seeUrl" />
        <span>{{post.pageview}}</span>
        <img style="margin-left: 30px;" :src="likeUrl" />
        <span>{{post.like}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import see from '@/assets/img/see.png'
import like from '@/assets/img/like.png'
export default {
  name: 'post-card',
  data () {
    return {
      seeUrl: see,
      likeUrl: like,
      sign: [{'content':'未过审', 'color': '#E70012'},{'content':'审核中', 'color': '#FEB705'},{'content':'草稿', 'color': 'grey'}]
    }
  },
  props: ['post', 'edit', 'uid', 'audit'],
  computed: {
  },
  methods: {
    ...mapActions("post", ["deletePost", "submitPost", "reasonPastPost"]),
    ...mapActions("userInfor", ["getUserPostList", "getUserAuditPosts"]),
    goPage () {
      window.open('/p/' + this.post._id + '?articleType=' + this.post.category2[0]._id)
    },
    editPost () {
      window.open('/writepost/' + this.post._id)
    },
    deleteUserPost () {
      this.$confirm(`此操作将永久删除文章 '${this.post.title}', 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await this.deletePost(this.post._id)
          await this.getUserPostList(this.uid)
          await this.getUserAuditPosts()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
        });
    },
    referUserPost () {
        this.$confirm(`此操作将提交审核文章 '${this.post.title}',是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            await this.submitPost(this.post._id)
            await this.getUserAuditPosts()
            await this.getUserPostList(this.uid)
            this.$message({
                type: 'success',
                message: '提交审核成功'
            });
        }).catch(() => {
        });
    },
    noPastUserPost () {
        this.$confirm(`文章 '${this.post.title}' 未通过审核,是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            await this.reasonPastPost({postId: this.post._id, auditState: 1})
            await this.getUserAuditPosts()
            await this.getUserPostList(this.uid)
            this.$message({
                type: 'success',
                message: '提交成功'
            });
        }).catch(() => {
        });
    },
    pastUserPost () {
        this.$confirm(`文章 '${this.post.title}' 通过审核,是否继续?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            await this.reasonPastPost({postId: this.post._id, auditState: 4})
            await this.getUserAuditPosts()
            await this.getUserPostList(this.uid)
            this.$message({
                type: 'success',
                message: '审核成功'
            });
        }).catch(() => {
        });
    }
  }
}
</script>
<style lang="scss" scoped>
.post-card {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-between;
  height: 193px;
  width: 850px;
  padding: 23px 0;
  color: #333333;
  >.post-card-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 3px;
    >.post-card-img {
      width: 233px;
      height: 105px;
      border-radius: 4px;
      &:hover{
        cursor: pointer;
      }
    }
    >.post-card-content {
      width: 603px;
      height: 105px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      >.post-card-title {
        font-size: 18px;
        font-weight: bold;
        height: 24px;
        line-height: 24px;
        &:hover {
          cursor: pointer;
        }
        .title-content{
          vertical-align: middle;
        }
        .sign{
          display: inline-block;
          border-radius:2px;
          height: 15px;
          font-size: 12px;
          line-height: 15px;
          text-align: center;
          margin-left: 12px;
          margin-bottom: 1px;
          padding: 0 6px;
          vertical-align: middle;
        }
      }
      >.post-card-context {
        font-size: 13px;
        color: rgba(153,153,153,1);
        line-height: 24px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      >.post-card-tag {
        >:not(:first-child) {
          margin-left: 12px;
        }
        >span {
          background: rgba(248,248,248,1);
          border-radius: 2px;
          display: inline-block;
          height: 24px;
          line-height: 24px;
          padding: 0 12px;
        }
      }
    }
  }
  >.post-card-infor {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    >.post-card-tools {
      display: flex;
      align-items: center;
      margin-right: 30px;
      vertical-align: middle;
      >* {
       margin-right: 4px;
      }
      &:hover {
        cursor: pointer;
      }
      > .user-edit {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/img/useredit.png");
        background-size: cover;
      }
       > .user-delete {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/img/icon-delete.png");
        background-size: cover;
      }
      >.user-submitaudit{
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/img/submitaduit.png");
        background-size: cover;
      }
      >.user-noreview {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/img/noreview.png");
        background-size: cover;
      }
      >.user-finishreview {
        display: inline-block;
        width: 20px;
        height: 20px;
        background-image: url("../../assets/img/finishreview.png");
        background-size: cover;
      }
    }
    >.post-card-user {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      >img {
        width: 26px;
        height: 26px;
        border-radius: 13px;
      }
      > * {
        margin-right: 10px;
      }
    }
    >.post-card-follow {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-weight:bold;
      color:rgba(153,153,153,1);
      >img {
        width: 20px;
      }
      >* {
        margin-left: 4px;
      }
    }
  }
}
</style>



